import React, { useEffect, useRef } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { FaAirbnb, FaWhatsapp, FaInstagram } from "react-icons/fa";
import gsap from "gsap";
// import logo from "../assets/tao_logo_full.png";

// Register GSAP plugin
gsap.registerPlugin(ScrollTrigger);

// Import your assets
// import bgImage from "../assets/Tao_background.png";
// import livingRoom from "../assets/tao-living.png";
// import philosophyImg from "../assets/img3.avif";
// import philosophyImg1 from "../assets/img3-1.avif";
// import fourImg from "../assets/img4.avif";

// import livingRoomSmall1 from "../assets/living1.avif";
// import livingRoomSmall2 from "../assets/living2.avif";
// import diningRoomMain from "../assets/dining.avif";
// import diningRoomSmall1 from "../assets/dining1.avif";
// import diningRoomSmall2 from "../assets/dining2.avif";
// import bedroomMain from "../assets/bedroom1.avif";
// import bedroomSmall1 from "../assets/bedroom2.avif";
// import bedroomSmall2 from "../assets/bedroom3.avif";

// import finalImage from "../assets/section8.avif";
// import servicesImage from "../assets/section9.avif";
// import locationImage from "../assets/section10.avif";

const Test = () => {
  const horizontalRef = useRef(null);

  useEffect(() => {
    const sections = gsap.utils.toArray(".panel");

    gsap.to(sections, {
      xPercent: -100 * (sections.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: horizontalRef.current,
        pin: true,
        scrub: 1, //
        snap: 0.1 / (sections.length - 1),
        end: "+=" + horizontalRef.current.offsetWidth * 5, //
      },
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <div className="relative w-full overflow-hidden">
      {/* ------------------SECTION 1--------------- */}
      <div
        className="hidden lg:flex fixed top-0 left-0 w-full h-screen flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url("https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public")`,
        }}
      >
        <div className="relative z-10 flex flex-col items-center justify-center text-center text-[#F5F2F0]">
          <img
            src="../assets/tao_logo_full.png"
            alt="House of Tao"
            className="w-[200px] lg:w-[130px] mt-2"
          />
        </div>

        <p className="absolute bottom-7 lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] font-light tracking-[0.20em] uppercase text-[#f5f5f0] z-10 text-center">
          where stillness becomes a destination
        </p>
      </div>

      {/* ---------- SECTION 2 (Responsive) ---------- */}
      <div className="hidden lg:grid relative mt-[110vh] z-10 w-full bg-white -mb-12 grid-cols-[2fr_1fr]">
        {/* LEFT IMAGE */}
        <div className="relative w-[85%] lg:w-[110%] xl:w-[115%] 2xl:w-[115%] h-[70vh] lg:h-[100vh] xl:h-[101vh] 2xl:h-[101vh] overflow-hidden">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public"
            alt="Living Room"
            className="object-cover w-full h-full"
          />
        </div>

        {/* RIGHT TEXT SECTION */}
        <div className="flex items-end justify-end px-8 sm:px-12 lg:px-16 py-10 2xl:py-20">
          <div
            className=" text-[#948A78] leading-[1.9] font-light tracking-wide text-right space-y-2 mb-1 
            lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] 2xl:translate-y-6"
          >
            <p>
              A space to pause, <br />
              to feel the wind move <br />
              through arches, <br />
              to watch the light <br />
              fall without urgency.
            </p>

            <p>
              Rooted in Taoist principles <br />
              of balance and presence, <br />
              our home is crafted to <br />
              help you return to yours — <br />
              the one within.
            </p>

            <p>
              Come as you are. <br />
              Leave a little lighter.
            </p>
          </div>
        </div>
      </div>

      {/* ----------SECTION 3---------- */}
      <div className="hidden lg:flex relative z-10 w-full items-center justify-between py-20 px-6 md:px-10 bg-white">
        {/* LEFT IMAGE */}
        <div className="w-full md:w-1/2 flex justify-start mb-8 md:mb-6 -mt-10">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1a111f92-cd9a-45c7-37f8-8e76740bf700/public"
            alt="Philosophy"
            className="shadow-lg lg:w-[100%] xl:w-[90%] 2xl:w-[90%] 4k:w-[100%] h-auto object-cover"
          />
        </div>

        {/* TEXT SECTION */}
        <div
          className="md:w-1/2 text-[#948A78] text-[12px] lg:text-[13px] 2xl:text-[17px]
                    font-light leading-[1.9] tracking-wide space-y-3 md:pl-12 text-left relative"
        >
          {/* Heading */}
          <div className="flex justify-end pr-[85%] 4k:pl-96">
            <h2
              className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] font-medium 
                                text-[#948A78] text-right leading-snug mb-0"
            >
              Our <br /> Philosophy
            </h2>
          </div>

          {/* Paragraphs */}
          <div
            className="flex flex-col items-end pr-[2%] space-y-2
                      text-[13px] 2xl:text-base lg:ml-[70px] xl:ml-[65px] 2xl:ml-[120px] 4k:ml-[380px]
                      w-[350px]"
          >
            <p>
              House of Tao is designed to help you disconnect from noise and
              reconnect with what matters: nature, rest, and self.
            </p>
            <p>
              We follow Taoist principles: living in alignment with the natural
              world, choosing presence over pace and embracing the simple beauty
              of each moment.
            </p>
            <p>
              From the outside, it’s quiet and grounded. But step in and you’ll
              feel something shift — not because of grand gestures or luxury for
              luxury’s sake, but because every corner has been thought through.
            </p>
            <p>
              Here, beauty is not about perfection. It’s about presence — in the
              way light moves through a room, in how time begins to stretch, in
              how you begin to return to yourself.
            </p>

            {/* SPACE */}
            <div className="lg:h-5 xl:h-12 2xl:h-16 4k:h-16"></div>

            {/* WELCOME LINE */}
            <div className="flex justify-between items-center w-full max-w-[350px]">
              <p className="text-right text-base lg:mb-10">
                Welcome home. To yourself.
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="hidden lg:flex w-full md:w-1/2 justify-end -mt-96 mb-6 -mr-2 ml-4">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public"
            alt="Philosophy1"
            className="shadow-lg lg:w-[95%] xl:w-[80%] 2xl:w-[75%] 4k:w-[85%] h-auto object-cover"
          />
        </div>
        <div
          className="absolute bottom-28 right-[10%] xl:right-[11%] 2xl:right-[12%] 4k:right-[19%]
                    text-[13px] z-50"
        >
          <div className="flex items-center space-x-12 text-[#948A78]">
            <p className="text-base font-light tracking-widest uppercase cursor-pointer underline lg:mb-3 4k:mb-60">
              Learn more
            </p>
          </div>
        </div>
      </div>

      {/* ----------SECTION 4---------- */}
      <div className="hidden lg:flex relative w-full flex-col-reverse md:flex-row items-end justify-between -mt-10 -mb-1 bg-white py-0 md:py-1 px-6 md:px-10 pb-20">
        {/* IMAGE SECTION */}
        <div className="w-full md:w-2/3 flex justify-center md:justify-start md:order-1 order-2">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1b5553c7-0d3e-4ec8-4240-3a650b494800/public"
            alt="Modern Architecture"
            className="w-full lg:max-w-[600px] xl:max-w-[910px] 2xl:max-w-[900vh] 3xl:max-w-[1000vh] 4k:max-w-[1300vh] h-auto object-cover rounded-none transition-all duration-500"
          />
        </div>

        {/* TEXT SECTION */}
        <div className="w-full md:w-1/3 flex justify-center md:justify-end mt-6 md:mt-0 md:order-2 order-1">
          <div className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] leading-relaxed text-left font-light tracking-wide md:ml-10 md:mb-10">
            <p>
              A 5-bedroom home with ensuite baths, vaulted living, sun-washed
              courtyards, a private pool, and an open-sky jacuzzi — designed for
              connection and calm.
            </p>
          </div>
        </div>
      </div>

      {/* ---------- FIFTH to SEVENTH SECTIONS---------- */}
      <div
        ref={horizontalRef}
        className="hidden lg:block w-full h-screen overflow-hidden bg-white mt-0"
      >
        <div className="flex w-[300vw] h-full">
          {/* ---------- SECTION 5: LIVING ROOM ---------- */}
          <section className="panel w-screen flex-shrink-0 flex items-center justify-center bg-white mt-16">
            <div
              className="relative z-10 w-full flex flex-col md:flex-row bg-white pt-10 pb-24 
                            px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
            >
              {/* ---------- LEFT COLUMN ---------- */}
              <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
                {/* Main Dining Image */}
                <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fcfaf156-fd7c-485a-1734-e3a3ace3c900/public"
                    alt="Living Room"
                    className="
                       lg:w-[400px] xl:w-[550px] 2xl:w-[80vh] 3xl:w-[55vh] 4k:w-[80vh]
                       lg:h-[260px] xl:h-[400px] 2xl:h-[48vh] 3xl:h-[48vh] 4k:h-[48vh]
                      object-cover shadow-lg transition-all duration-300"
                  />
                  <div
                    className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
                              4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
                              transform -translate-y-1/2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
                    >
                      <path
                        d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
                        stroke="#948A78"
                        stroke-width="1.0"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>

                {/* Bottom Left Text */}
                <div
                  className="lg:w-[98%] xl:w-[90%] 2xl:w-[520px] 4k:w-[550px]
                            lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                            leading-relaxed font-light tracking-wide text-[#948A78]"
                >
                  <p className="mb-4">
                    This space is designed for pause. <br />
                    For conversation. <br />
                    For silence. <br />
                    For everything in between.
                  </p>
                  <p className="mb-4">
                    One seating is a deep, sectional sofa, perfect for long
                    hours and even longer conversations. Another faces the TV,
                    for easy, familiar comfort. In one corner, a round window
                    offers a cozy reading spot.
                  </p>
                  <p className="mb-4">
                    There’s also a small bar tucked into the space, ideal for an
                    evening drink.
                  </p>
                </div>
              </div>

              {/* ---------- RIGHT COLUMN ---------- */}
              <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
                {/* The Space at a Glance */}
                <div
                  className="grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1200px] mx-auto 
                            px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 4k:px-24 
                            mb-12 md:mb-0 md:pt-7 gap-y-8 lg:gap-x-12"
                >
                  {/* ---------- COLUMN 1 ---------- */}
                  <div className="flex flex-col justify-center items-start  space-y-4">
                    <div className="text-right -ml-32">
                      <h2
                        className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] font-medium 
                                  text-[#948A78] leading-snug mb-0 "
                      >
                        The Space at <br /> a Glance.
                      </h2>
                    </div>

                    <div
                      className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
                                lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                                leading-relaxed font-light tracking-wide text-[#948A78]"
                    >
                      <p className="mb-0 mt-0">
                        A 5-bedroom home with ensuite baths, vaulted living,
                        sun-washed courtyards, a private pool, and an open-sky
                        jacuzzi — designed for connection and calm.
                      </p>
                    </div>
                    <div>
                      <span
                        className="relative inline-block font-light tracking-widest uppercase cursor-pointer 
                                text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                                after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:w-full after:h-[1px] after:bg-[#948A78]"
                      >
                        OUR SPACES
                      </span>
                    </div>
                  </div>
                </div>

                {/* <div className="relative w-full max-w-[600px] 2xl:max-w-[480px] mx-auto md:mx-0 mb-12 md:mb-0 md:pt-7 
                                px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 4k:px-6">
                  
                  <div className="relative w-full max-w-[600px] 2xl:max-w-[480px] mx-auto md:mx-0 mb-12 md:mb-0 md:pt-7 
                                px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 4k:px-6">
                  <div className=" 
                                  lg:-ml-72 lg:w-[280px]
                                  xl:-ml-72 xl:w-[240px]
                                   2xl:w-[200px] 
                                  4k:-ml-64 4k:w-[400px]">
                    <h2 className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] font-medium 
                                text-[#948A78] text-right leading-snug mb-0">
                      The Space at <br /> a Glance.
                    </h2>
                  </div>
                  <div
                    className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
                              lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                              lg:mr-5  xl:-ml-12  2xl:-ml-20  4k:ml-36      
                              leading-relaxed font-light tracking-wide text-[#948A78]">
                    <p className="mb-0 mt-0">
                      A 5-bedroom home with ensuite baths, vaulted living, sun-washed courtyards, a private pool, 
                      and an open-sky jacuzzi — designed for connection and calm.
                    </p>
                  </div>
                </div>

                  <div className="pt-2 lg:ml-10  xl:ml-0  2xl:-ml-9  4k:ml-44">
                    <span
                      className="relative inline-block font-light tracking-widest uppercase cursor-pointer 
                                text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                                after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:w-full after:h-[1px] after:bg-[#948A78]">
                      OUR SPACES
                    </span>
                  </div>

                </div> */}

                {/* Bottom Right Images */}
                <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
                  <div className="flex justify-end items-center mb-6">
                    <span
                      className="tracking-widest uppercase text-[#948A78] 
                      lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]"
                    >
                      THE LIVING ROOM
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3 
                                transition-transform duration-300 hover:translate-x-1"
                    >
                      <path
                        d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                        stroke="#948A78"
                        strokeWidth="1.5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
                    <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
                      {/* First Image */}
                      <div className="w-full sm:w-1/2">
                        <div className="lg:h-[200px] xl:h-[320px] 2xl:h-[50vh] 4k:h-[500px]">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1161b68c-2cc3-4357-0627-906f1a32ae00/public"
                            alt="living Detail 1"
                            className="w-full h-full object-cover shadow-lg"
                          />
                        </div>
                      </div>

                      {/* Second Image */}
                      <div className="w-full sm:w-1/2">
                        <div className="lg:h-[200px] xl:h-[320px] 2xl:h-[50vh] 4k:h-[500px]">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0cd34eb7-aa12-492a-ed1d-de2c1ede2100/public"
                            alt="living Detail 2"
                            className="w-full h-full object-cover shadow-lg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* SECTION 6*/}
          <section className="panel w-screen flex-shrink-0 flex items-center justify-center bg-white mt-16">
            <div
              className="relative z-10 w-full flex flex-col md:flex-row bg-white pt-10 pb-24 
                            px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
            >
              {/* ---------- LEFT COLUMN ---------- */}
              <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
                {/* Main Dining Image */}
                <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ceaeea20-ecae-44e3-69c7-7a2510d71c00/public"
                    alt="Dining Room"
                    className="
                      lg:w-[400px] xl:w-[550px] 2xl:w-[80vh] 4k:w-[1000px]
                      lg:h-[260px] xl:h-[400px] 2xl:h-[48vh] 4k:h-[650px]
                      object-cover shadow-lg transition-all duration-300"
                  />
                  <div
                    className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
                              4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
                              transform -translate-y-1/2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
                    >
                      <path
                        d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
                        stroke="#948A78"
                        stroke-width="1.0"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>

                {/* Bottom Left Text */}
                <div
                  className="w-full sm:w-[90%] md:w-[90%] lg:w-[98%] xl:w-[90%] 2xl:w-[520px] 
                            lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                            leading-relaxed font-light tracking-wide text-[#948A78]"
                >
                  <p className="mb-4">
                    The dining space brings people together, it seats 14 with
                    ease and opens straight onto the verandah, so the breeze
                    flows in without asking.
                  </p>
                  <p className="mb-4">
                    The light above the table isn’t grand, but it’s quietly
                    special, made with layered fabric, stitched by a local
                    tailor who understood what we were trying to create.
                  </p>
                  <p className="mb-4">
                    When the wind moves through, the light shifts just a little.
                    It’s a space that feels open, gentle and lived in. Meals
                    here tend to stretch longer than planned and that’s exactly
                    how we like it.
                  </p>
                </div>
              </div>

              {/* ---------- RIGHT COLUMN ---------- */}
              <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
                {/* The Space at a Glance */}
                <div
                  className="relative w-full max-w-[600px] 2xl:max-w-[480px] mx-auto md:mx-0 mb-12 md:mb-0 md:pt-7 
                                px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 4k:px-6"
                >
                  <div
                    className="relative w-full max-w-[600px] 2xl:max-w-[480px] mx-auto md:mx-0 mb-12 md:mb-0 md:pt-7 
                                px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 4k:px-6"
                  >
                    <div
                      className="md:-ml-16 
                                  lg:-ml-72 lg:w-[280px]
                                  xl:-ml-72 xl:w-[240px]
                                  2xl:-ml-64 2xl:w-[150px] 
                                  4k:-ml-64 4k:w-[400px]"
                    >
                      <h2
                        className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] font-medium 
                                text-[#948A78] text-right leading-snug mb-0"
                      >
                        The Space at <br /> a Glance.
                      </h2>
                    </div>

                    <div
                      className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
                              lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                              lg:mr-5  xl:-ml-12  2xl:-ml-24  4k:ml-36      
                              leading-relaxed font-light tracking-wide text-[#948A78]"
                    >
                      <p className="mb-0 mt-0">
                        A 5-bedroom home with ensuite baths, vaulted living,
                        sun-washed courtyards, a private pool, and an open-sky
                        jacuzzi — designed for connection and calm.
                      </p>
                    </div>
                  </div>

                  <div className="pt-2 lg:ml-10  xl:ml-0  2xl:-ml-12  4k:ml-44">
                    <span
                      className="relative inline-block font-light tracking-widest uppercase cursor-pointer 
                                text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                                after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:w-full after:h-[1px] after:bg-[#948A78]"
                    >
                      OUR SPACES
                    </span>
                  </div>
                </div>

                {/* Bottom Right Images */}
                <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
                  <div className="flex justify-end items-center mb-6">
                    <span
                      className="tracking-widest uppercase text-[#948A78] 
                      lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]"
                    >
                      THE DINING ROOM
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3 
                                transition-transform duration-300 hover:translate-x-1"
                    >
                      <path
                        d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                        stroke="#948A78"
                        strokeWidth="1.5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
                    <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
                      {/* First Image */}
                      <div className="w-full sm:w-1/2">
                        <div className="lg:h-[200px] xl:h-[320px] 2xl:h-[50vh] 4k:h-[500px]">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/81c74f48-70f8-4172-30e6-0b764fcf1100/public"
                            alt="Dining Detail 1"
                            className="w-full h-full object-cover shadow-lg"
                          />
                        </div>
                      </div>

                      {/* Second Image */}
                      <div className="w-full sm:w-1/2">
                        <div className="lg:h-[200px] xl:h-[320px] 2xl:h-[50vh] 4k:h-[500px]">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/6de079fb-a125-449c-48d4-4b788fcc6a00/public"
                            alt="Dining Detail 2"
                            className="w-full h-full object-cover shadow-lg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* SECTION 7 */}
          <section className="panel w-screen flex-shrink-0 flex items-center justify-center bg-white mt-16">
            <div
              className="relative z-10 w-full flex flex-col md:flex-row bg-white pt-10 pb-24 
                            px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
            >
              {/* ---------- LEFT COLUMN ---------- */}
              <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
                {/* Main Dining Image */}
                <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ede13113-bdec-4b3c-9d08-4e21ed82b700/public"
                    alt="bedroom"
                    className="
                      lg:w-[400px] xl:w-[550px] 2xl:w-[80vh] 4k:w-[1000px]
                      lg:h-[260px] xl:h-[400px] 2xl:h-[48vh] 4k:h-[650px]
                      object-cover shadow-lg transition-all duration-300"
                  />
                  <div
                    className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
                              4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
                              transform -translate-y-1/2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
                    >
                      <path
                        d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
                        stroke="#948A78"
                        stroke-width="1.0"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>

                {/* Bottom Left Text */}
                <div
                  className="w-full sm:w-[90%] md:w-[90%] lg:w-[98%] xl:w-[90%] 2xl:w-[520px] 
                            lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                            leading-relaxed font-light tracking-wide text-[#948A78]"
                >
                  <p className="mb-4">
                    In a quiet corner, tea is brewed not for caffeine but for
                    consciousness. The ritual is simple, almost sacred.
                  </p>
                  <p className="mb-4">
                    Sip. Pause. Tap the table softly when the cup is empty, a
                    gesture of thanks. The house honors Taoism, not through
                    symbols, but through rhythm.
                  </p>
                  <p className="mb-4">
                    Be here & now. <br />
                    That’s the only rule. <br />
                    That’s the only truth.
                  </p>
                </div>
              </div>

              {/* ---------- RIGHT COLUMN ---------- */}
              <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
                {/* The Space at a Glance */}
                <div
                  className="relative w-full max-w-[600px] 2xl:max-w-[480px] mx-auto md:mx-0 mb-12 md:mb-0 md:pt-7 
                                px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 4k:px-6"
                >
                  <div
                    className="relative w-full max-w-[600px] 2xl:max-w-[480px] mx-auto md:mx-0 mb-12 md:mb-0 md:pt-7 
                                px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 4k:px-6"
                  >
                    <div
                      className="md:-ml-16 
                                  lg:-ml-72 lg:w-[280px]
                                  xl:-ml-72 xl:w-[240px]
                                  2xl:-ml-64 2xl:w-[150px] 
                                  4k:-ml-64 4k:w-[400px]"
                    >
                      <h2
                        className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] font-medium 
                                text-[#948A78] text-right leading-snug mb-0"
                      >
                        The Space at <br /> a Glance.
                      </h2>
                    </div>

                    <div
                      className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
                              lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                              lg:mr-5  xl:-ml-12  2xl:-ml-24  4k:ml-36      
                              leading-relaxed font-light tracking-wide text-[#948A78]"
                    >
                      <p className="mb-0 mt-0">
                        A 5-bedroom home with ensuite baths, vaulted living,
                        sun-washed courtyards, a private pool, and an open-sky
                        jacuzzi — designed for connection and calm.
                      </p>
                    </div>
                  </div>

                  <div className="pt-2 lg:ml-10  xl:ml-0  2xl:-ml-12  4k:ml-44">
                    <span
                      className="relative inline-block font-light tracking-widest uppercase cursor-pointer 
                                text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                                after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:w-full after:h-[1px] after:bg-[#948A78]"
                    >
                      OUR SPACES
                    </span>
                  </div>
                </div>

                {/* Bottom Right Images */}
                <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
                  <div className="flex justify-end items-center mb-6">
                    <span
                      className="tracking-widest uppercase text-[#948A78] 
                      lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]"
                    >
                      Bedroom 01
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3 
                                transition-transform duration-300 hover:translate-x-1"
                    >
                      <path
                        d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                        stroke="#948A78"
                        strokeWidth="1.5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
                    <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
                      {/* First Image */}
                      <div className="w-full sm:w-1/2">
                        <div className="lg:h-[200px] xl:h-[320px] 2xl:h-[50vh] 4k:h-[500px]">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/edddf9f8-8327-4621-09d2-3985d5991200/public"
                            alt="Bedroom 01"
                            className="w-full h-full object-cover shadow-lg"
                          />
                        </div>
                      </div>

                      {/* Second Image */}
                      <div className="w-full sm:w-1/2">
                        <div className="lg:h-[200px] xl:h-[320px] 2xl:h-[50vh] 4k:h-[500px]">
                          <img
                            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/72c33a33-1c06-4e0d-397e-6cc70d5be300/public"
                            alt="Bedroom 02"
                            className="w-full h-full object-cover shadow-lg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* ---------- SECTION 8 (IMAGE UPLOADED) ---------- */}
      <div className="hidden lg:flex relative w-full min-h-screen items-center justify-center bg-white z-10 pt-16 -mb-10 -mt-1 py-0 md:py-1 pb-20 md:pb-10">
        <div className="w-full h-[70vh] md:h-screen relative">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/674a0f9e-4709-4fd8-9d3e-827e3707a500/public"
            alt="'IN SILENCE, EVERYTHING SPEAKS'"
            className="w-full h-[100vh] lg:h-[100vh] xl:h-[110vh] 2xl:h-[100vh] 4k:h-[100vh] object-cover"
          />
          <div className="absolute left-0 right-0 bottom-0 text-center pb-0 md:pb-10">
            <p className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] font-light tracking-widest uppercase -mb-16 lg:mb-2 xl:mb-1 2xl:mb-1">
              IN SILENCE, EVERYTHING SPEAKS
            </p>
          </div>
        </div>
      </div>

      {/* ---------- SECTION 9 (SERVICES) ---------- */}
      <div className="hidden lg:block relative w-full bg-white py-16 sm:py-20 lg:py-24 px-4 sm:px-8 md:px-12 lg:px-7 xl:px-28 2xl:px-40 4k:px-48 z-20 -mb-1">
        <div className="flex flex-col lg:flex-row justify-between gap-12 xl:gap-24 4k:gap-36">
          {/* ---------- LEFT COLUMN ---------- */}
          <div className="w-full lg:w-1/2 flex flex-col order-1 lg:order-1">
            <h2 className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] font-light tracking-wide text-[#948A78] mb-6 pb-0">
              OUR SERVICES
            </h2>

            <p className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] leading-relaxed font-light tracking-wide mb-16">
              Curated experiences, thoughtfully delivered At House of Tāo, our
              in-house concierge service is here to enhance your stay with
              curated experiences, local insights, and seamless planning — so
              you can focus on unwinding.
            </p>

            {/* ---------- IMAGE ---------- */}
            <div className="w-full mt-8 sm:mt-10 mb-0 order-3 lg:order-1">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7d785301-7c6b-4a1d-87be-dd345efddd00/public"
                alt="Concierge services by the pool"
                className="w-[80vh] h-auto object-cover shadow-lg"
              />
            </div>
          </div>

          {/* ---------- RIGHT COLUMN ---------- */}
          <div
            className="w-full lg:w-1/2 flex flex-col justify-end items-end order-2 lg:order-2 
                      4k:pl-40 4k:pr-16"
          >
            <div className="w-full 4k:max-w-[70%]">
              <div className="4k:-ml-56 2xl:ml-4 xl:ml-6 lg:ml-0">
                <h2 className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] font-light tracking-wide text-[#948A78] mb-1">
                  What We Offer
                </h2>
              </div>

              <div className="4k:-ml-20 2xl:mr-10 2xl:w-[600px] xl:ml-44 lg:ml-16">
                <p className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] leading-relaxed font-light tracking-wide mb-2">
                  Our concierge can assist you with:
                </p>

                <div
                  className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] 4k:w-[690px] 
                  leading-relaxed font-light tracking-wide space-y-1 mb-8"
                >
                  <p>
                    • Restaurant reservations at some of Goa’s best culinary
                    spots
                  </p>
                  <p>• Private transfers & guided itineraries</p>
                  <p>
                    • Spa appointments, wellness sessions & yoga instructors
                  </p>
                  <p>• Decor for intimate celebrations</p>
                  <p>• On-call chef experiences & wine/gin tastings</p>
                  <p>• Yacht charters, beach picnics & cultural explorations</p>
                </div>

                <p
                  className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                  lg:w-[450px] xl:w-[500px] 2xl:w-[500px] 4k:w-[500px] leading-relaxed font-light tracking-wide mb-6"
                >
                  All in-villa services (spa, setup, décor, etc.) must be booked
                  through our concierge to ensure quality, safety, and
                  consistency of service.
                </p>

                <p
                  className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                  lg:w-[450px] xl:w-[500px] 2xl:w-[460px] 4k:w-[500px] leading-relaxed font-light tracking-wide 2xl:mb-6"
                >
                  We’re here to ensure your stay is not only peaceful, but
                  seamless — curated with care, hosted with intention. For any
                  assistance, please reach out to your Villa Manager or
                  Concierge Team directly during your stay.
                </p>
              </div>

              <div className="pt-2 4k:-ml-20 2xl:ml-44 2xl:w-[600px] xl:ml-44 lg:ml-16 mb-2">
                <span
                  className="relative inline-block font-medium tracking-widest uppercase cursor-pointer 
                    text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px]
                    after:content-[''] after:absolute after:left-0 after:bottom-0 
                    after:w-full after:h-[1px] after:bg-[#948A78]"
                >
                  explore our services
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- SECTION 10 ---------- */}
      <div className="hidden lg:block relative w-full bg-white py-6 sm:py-8 md:py-10 lg:py-16 xl:py-20 2xl:py-20 4k:py-20 px-4 lg:px-0 xl:px-0 2xl:px-0 4k:px-0 z-10 mt-0">
        <div className="flex flex-col lg:flex-row justify-between items-stretch gap-10 xl:gap-16 2xl:gap-20 4k:gap-32">
          {/* ---------- LEFT COLUMN (TEXT) ---------- */}
          <div className="w-full lg:w-1/3 flex flex-col justify-end lg:pl-20 xl:pl-28 2xl:pl-36 4k:pl-48 2xl:mr-0 lg:mr-20 4k:mr-20 pb-8 lg:pb-12">
            <h2 className="lg:text-[20px] xl:text-[20px] 2xl:text-[20px] 4k:text-[20px] uppercase font-light tracking-wide text-[#948A78] mb-8 lg:mb-12 mt-6 lg:mt-8">
              Location & Surroundings
            </h2>

            <p className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] leading-relaxed font-light tracking-wide mb-6">
              A village where time moves a little slower. Parra has its own
              pace: calm, familiar and quietly alive.
            </p>

            <p className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] leading-relaxed font-light tracking-wide mb-6">
              It’s not where the parties are, but they’re not far either.
              Beaches like Anjuna and Vagator, and the cafés of Assagao, are
              just a short drive away.
            </p>

            <p className="text-[#948A78] lg:text-[13px] xl:text-[13px] 2xl:text-base 4k:text-[13px] leading-relaxed font-light tracking-wide">
              That’s what makes this place special: it gives you room to
              retreat, without losing touch with everything else.
            </p>
          </div>

          {/* ---------- RIGHT COLUMN (IMAGE) ---------- */}
          <div className="w-full lg:w-2/3 mt-8 lg:mt-0 flex justify-end">
            <img
              src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fe12801d-ae41-4ad6-ec2d-26935c679a00/public"
              alt="The spacious living room and staircase of the villa, looking out to the garden."
              className="w-full max-w-[1000px] 2xl:max-w-[1000px] h-auto object-cover rounded-none shadow-none"
            />
          </div>
        </div>
      </div>

      {/* ----------------Footer------------------ */}
      <div className="relative w-full py-0 md:py-10 z-10 mt-0 2xl:h-[75vh] 4k:h-[40vh] bg-[#ded9d4]">
        <div className="hidden lg:block">
          <div className="flex flex-col lg:flex-row justify-between gap-12">
            <footer
              className="relative w-full bg-[#ded9d4] text-[#948A78] flex flex-col 
              justify-start items-center px-6 md:px-10 pt-4 pb-10 overflow-hidden"
            >
              {/* ---------- MAIN CONTENT ---------- */}
              <div className="flex flex-col md:flex-row justify-between items-start w-full max-w-6xl gap-12 mt-0">
                {/* ---------- LEFT COLUMN ---------- */}
                <div className="flex flex-col space-y-4 w-full md:w-1/3">
                  <p className="lg:text-[13px] xl:text-[13px] font-medium text-right mr-44">
                    Slow down with Us.
                  </p>

                  <p className="lg:text-[13px] xl:text-[13px] font-medium text-right mr-36 w-52">
                    Scan to check availibility <br />
                    or speak with us
                  </p>

                  <div className="space-y-12 lg:text-[13px] font-light uppercase mt-8 mb-2">
                    <div className="space-y-5 ml-52">
                      <p>sohamvillas@gmail.com</p>
                      <p>+91 7767047535</p>
                      <p>@sohamvillas</p>
                    </div>

                    <div className="space-y-5 ml-52">
                      <p>houseoftao.goa@gmail.com</p>
                      <p>+91 8866262368</p>
                      <p>@houseoftao</p>
                    </div>
                  </div>
                </div>

                {/* ---------- RIGHT COLUMN ---------- */}
                <div className="grid grid-cols-1 gap-1 w-full md:w-1/2 md:pl-20">
                  <div className="md:-ml-16 lg:-ml-72 lg:w-[280px] xl:-ml-72 xl:w-[240px] 2xl:-ml-56 2xl:w-[220px] 4k:-ml-96 4k:w-[400px]">
                    <p className="lg:text-[13px] xl:text-[13px] font-medium mb-5 md:mb-1 mt-3 text-[#948A78] text-right leading-snug">
                      Be the First <br /> to Know
                    </p>
                  </div>

                  <p className="lg:text-[13px] xl:text-[13px] font-light text-left mr-36 mt-1">
                    Join the House of Tāo circle and receive early <br />
                    updates on bookings, curated experiences, <br />
                    and future retreats.
                  </p>

                  <form className="flex border-b border-[#9b8b7a] items-center pb-1 max-w-md ml-auto mr-72 mt-6">
                    <input
                      type="email"
                      placeholder="example@gmail.com"
                      className="flex-grow bg-transparent lg:text-[13px] outline-none placeholder-[#9b8b7a] text-left"
                    />
                    <button
                      type="submit"
                      className="ml-28 text-[#9b8b7a] uppercase lg:text-[13px]"
                    >
                      Connect
                    </button>
                  </form>
                </div>
              </div>

              {/* ---------- SOCIAL ICONS ---------- */}
              <div className="absolute bottom-1 right-28 flex justify-center items-center gap-8">
                <FaWhatsapp className="text-[#9b8b7a] text-[20px]" />
                <FaInstagram className="text-[#9b8b7a] text-[20px]" />
                <FaAirbnb className="text-[#9b8b7a] text-[20px]" />
              </div>
            </footer>
          </div>
        </div>

        {/* ---------- MOBILE / TABLET VERSION ---------- */}
        <div className="block lg:hidden">
          <footer className="w-full bg-[#ded9d4] text-[#948A78] flex flex-col justify-start items-center px-4 sm:px-6 py-10 text-center">
            {/* ---------- Be the First to Know ---------- */}
            <div className="flex flex-col items-center mb-10">
              <div className="mr-48 md:mr-60">
                <p className="text-[13px] sm:text-[13px] md:text-[13px] text-right font-medium mb-3 text-[#948A78] leading-snug">
                  Be the First <br /> to Know
                </p>
              </div>

              <p
                className="text-[13px] sm:text-[12px] md:text-[13px] ml-32 md:ml-60
            font-light mb-5 text-left max-w-[300px] sm:max-w-[340px] md:max-w-[400px]"
              >
                Join the House of Tāo circle and receive early updates on
                bookings, curated experiences, and future retreats.
              </p>

              <form
                className="flex border-b border-[#9b8b7a] items-right justify-right pb-1 ml-32 md:ml-60
                            w-[220px] sm:w-[260px] md:w-[280px] mx-auto"
              >
                <input
                  type="email"
                  placeholder="name@gmail.com"
                  className="flex-grow bg-transparent text-[12px] sm:text-[13px] outline-none placeholder-[#9b8b7a] text-left"
                />
                <button
                  type="submit"
                  className="ml-4 text-[#9b8b7a] uppercase text-[12px] sm:text-[13px]"
                >
                  Connect
                </button>
              </form>
            </div>

            {/* ---------- Slow down with Us ---------- */}
            <div className="flex flex-col items-center text-center mt-6">
              <div className="mr-48 md:mr-64">
                <p className="text-[14px] sm:text-[13px] md:text-[14px] font-medium mb-6">
                  Slow down <br /> with Us
                </p>
              </div>

              <div className="space-y-8 text-[12px] sm:text-[13px] md:text-[13px] font-light uppercase text-left ml-16 md:ml-10">
                <div className="space-y-3">
                  <p>houseoftao.goa@gmail.com</p>
                  <p>+91 8866262368</p>
                  <p>@houseoftao</p>
                </div>

                <div className="space-y-3">
                  <p>sohamvillas@gmail.com</p>
                  <p>+91 7767047535</p>
                  <p>@sohamvillas</p>
                </div>
              </div>
            </div>

            {/* ---------- Social Icons ---------- */}
            <div className="flex justify-center items-center gap-8 mt-10">
              <FaWhatsapp className="text-[#9b8b7a] text-[18px] sm:text-[20px]" />
              <FaInstagram className="text-[#9b8b7a] text-[18px] sm:text-[20px]" />
              <FaAirbnb className="text-[#9b8b7a] text-[18px] sm:text-[20px]" />
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Test;
